import routes from '@configs/api'

export const GET_REFERRAL_EARNING_URL = (params: string) => {
  return routes.REFERRAL + `/earnings?${params}`
}
export const GET_REFERRAL_USER_URL = (userId: string) => {
  return routes.REFERRAL + `/user/${userId}`
}
export const GET_COUNTRIES_STATS_URL = () => {
  return routes.REFERRAL + `/country-percentages`
}
export const GET_OS_STATS_URL = () => {
  return routes.REFERRAL + `/os-percentages`
}
export const GET_TOP_COURSES_URL = () => {
  return routes.REFERRAL + `/top-courses`
}
export const GET_GRAPH_DATA_URL = (
  period: 'daily' | 'monthly' | 'weekly' | 'yearly'
) => {
  return routes.REFERRAL + `/stats/graphs?timePeriod=${period}`
}
export const GET_REFERRAL_STATS = (
  startDate: string | Date,
  endDate: string | Date
) => {
  return (
    routes.REFERRAL_STATISTICS + `?startDate=${startDate}&endDate=${endDate}`
  )
}
